module.exports = __webpack_public_path__ + "static/img/success4.b60a2661.png";